export default {
  ContactType: {
    GeneralPartner: 1,
    LimitedPartner: 2,
    RegionalContact: 3,
    LeasingAgent: 4,
    ComplianceContact: 5,
    PrimaryContact: 6,
    OccupancyContact: 7,
    FinancialContact: 8
  }
};